import { Component, Shark } from "shark-mvc";
import { Modal } from "bootstrap";

import templateContent from "./wait-box.html";
import "./style.css";

class WaitBoxComponent extends Component {
	constructor () {
		super("waitBoxComponent");
		this.addTemplate("", templateContent);
	}

	afterLoad () {
		if (!this.modal) {
			const modalNode = document.querySelector("#waitBoxModal");

			if (modalNode) {
				this.modal = new Modal(modalNode, {
					keyboard: false
				});
			}
		}
	}
	
	close (mode) {
		if (this.modal) {
			this.modal.hide();
			
			const body = document.querySelector("body");
			body.classList.remove("wait-box-open");
			body.classList.remove("modal-open");
			body.style.removeProperty("padding-right");
			
			this.set("open", false);
		}
	}
	
	init () {
		this.set("open", false);
	}
	
	open () {
		if (this.modal) {
			document.querySelector("body").classList.add("wait-box-open");
			
			this.modal.show();
			
			this.set("open", true);
		}
	}
}

const waitBoxComponent = new WaitBoxComponent();

Shark.registerComponent(waitBoxComponent);

export default waitBoxComponent;
